module.exports = __webpack_public_path__ + "static/media/esquizofrenia.c65962e7.png";